/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash.get";
import React from "react";
import PropTypes from "prop-types";
import { getTextColor } from "../../../utils/utils";
import { useStateValue } from "../../SharedContext";
import "./read-time.m.css";
import { Dot } from "../Dot/dot";

export const ReadTime = ({ story, opts = {} }) => {
  const config = useStateValue() || {};
  const showReadTime = get(config, ["showReadTime"]) || get(opts, ["showReadTime"], true);
  const readTime = get(story, ["read-time"], 0);
  const textColor = getTextColor(config.theme);

  if (!showReadTime || !readTime) return null;

  const timeFormat = readTime > 1 ? "mins" : "min";

  return (
    <>
      <div
        className="arrow-component arr--read-time"
        styleName={`read-time-wrapper ${textColor}`}
        data-test-id="read-time"
      >
        <span styleName="dot-indicator">
          <Dot color={textColor} />
        </span>
        <span styleName="read-time">{`${readTime} ${timeFormat} read`}</span>
      </div>
    </>
  );
};

ReadTime.propTypes = {
  story: PropTypes.shape({
    "read-time": PropTypes.number
  }),
  opts: PropTypes.shape({
    showReadTime: PropTypes.bool
  })
};
